/** API 根地址，末尾不带斜杠。开发环境留空，走 devServer 代理 */
export const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

export function apiUrl(path) {
  return `${API_BASE}${path}`;
}
